import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-col">
              <h3>MARCUS Security</h3>
              <p>Empresa conformada por profesionales expertos en seguridad privada. Operamos bajo altos estándares internacionales basados en Normas ISO, leyes y decretos nacionales.</p>
              <div className="footer-cert">
                <img src="/images/os10-badge.png" alt="Autorización OS10 Carabineros de Chile" />

              </div>
            </div>

            <div className="footer-col">
              <h4>Servicios</h4>
              <ul>
                <li><Link to="/servicios#recursos-humanos">Recursos Humanos</Link></li>
                <li><Link to="/servicios#gestion-riesgos">Gestión de Riesgos</Link></li>
                <li><Link to="/servicios#auditorias">Auditorías</Link></li>
                <li><Link to="/servicios#fraudes">Prevención de Fraudes</Link></li>
                <li><Link to="/servicios#perdidas">Prevención de Pérdidas</Link></li>
                <li><Link to="/servicios#asesoria">Asesorías en Seguridad</Link></li>
                <li><Link to="/servicios#tecnologia">Tecnología y Proyectos</Link></li>
              </ul>
            </div>

            <div className="footer-col">
              <h4>Empresa</h4>
              <ul>
                <li><Link to="/empresa">Quiénes Somos</Link></li>
                <li><Link to="/empresa#mision-vision">Misión y Visión</Link></li>
                <li><Link to="/empresa#valores">Valores</Link></li>
                <li><Link to="/empresa#certificaciones">Autorizaciones</Link></li>
                <li><Link to="/empresa#clientes">Nuestros Clientes</Link></li>
                <li><Link to="/contacto">Trabaja con Nosotros</Link></li>
              </ul>
            </div>

            <div className="footer-col">
              <h4>Contacto</h4>
              <ul className="contact-info">
                <li>
                  <i className="icon-phone"></i>
                  <a href="tel:+56977911221">+56 9 7791 1221</a>
                </li>
                <li>
                  <i className="icon-email"></i>
                  <a href="mailto:asalinas@marcussecurity.cl">asalinas@marcussecurity.cl</a>
                </li>
                
                <li>
                  <i className="icon-location"></i>
                  Limache 3421, Oficina 723<br />
                  Viña del Mar, V Región
                </li>
              </ul>
              <div className="social-links">
                <a href="https://www.facebook.com/marcussecurity" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><i className="icon-facebook"></i></a>
                <a href="https://www.linkedin.com/company/marcus-security" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><i className="icon-linkedin"></i></a>
                <a href="https://www.instagram.com/marcussecurity" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><i className="icon-instagram"></i></a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <p>&copy; {currentYear} Salinas y Bensa Seguridad Privada SPA - Marcus Security. Todos los derechos reservados.</p>
            <p className="footer-legal">RUT: 76.261.664-5 | Autorizada por Carabineros de Chile (OS10)</p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;